import { useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { SplitViewPane } from '@/components/SplitViewPane';
import { useOrganizationId } from '@/hooks/useSwr';

import { ConversationV2 } from './ConversationV2';
import { getThreadUrl } from './utils/getThreadUrl';

interface ConversationPaneProps {
  open: boolean;
  onClose: () => void;
  onNext?: () => void;
  onPrevious?: () => void;
}

export function ConversationPane({
  open,
  onClose,
  onNext,
  onPrevious,
}: ConversationPaneProps) {
  const navigate = useNavigate();
  const { sessionId } = useParams();
  const [searchParams] = useSearchParams();

  const organizationId = useOrganizationId();
  const peekedConversationId = searchParams.get('peekedConversationId');

  const handleExpand = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (peekedConversationId && sessionId) {
        // Navigate to the full thread view
        navigate(getThreadUrl(organizationId, sessionId, peekedConversationId));
      }
    },
    [navigate, peekedConversationId, sessionId, organizationId]
  );

  return (
    <SplitViewPane
      open={open}
      onClose={onClose}
      onExpand={handleExpand}
      onNext={onNext}
      onPrevious={onPrevious}
      sidePaneId="conversation-pane"
      defaultWidth={800}
      title={null}
    >
      <ConversationV2 isPage={false} />
    </SplitViewPane>
  );
}
